<template>
  <div class="bar-1">
    <div class="news">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url },
          })
        "
        class="card"
        :class="`card-${index + 1}`"
        v-for="(item, index) in list"
        :key="item.id"
      >
        <div class="background-color"></div>
        <div class="card__img">
          <ImageContainer
            class="img"
            :src="item.image.medium"
            :thumb="item.image.thumbnail"
            :alt="item.title"
          />
        </div>
        <div class="card__content">
          <div class="opacity-content"></div>
          <div class="card__category">
            <div>{{ item.sub_category.name }}</div>
          </div>
          <div class="card__title">
            <h3 class="limited-text">
              {{ item.title }}
            </h3>
            <p class="card__brief limited-text">{{ item.brief }}</p>
          </div>
          <div class="data-news">
            <span class="day">{{ handleDate(item.pub_date) }},</span>
            <span class="time">{{ handleTime(item.pub_date) }}</span>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import ImageContainer from "@/components/ImageContainer";
import { useFormatter } from "@/utils/formatter";

export default {
  components: { ImageContainer },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup() {
    return {
      ...useFormatter(),
    };
  },
};
</script>

<style lang="scss" scoped>
.bar-1 {
  width: 90%;
  padding-top: 6rem;
}
.card {
  position: relative;
  z-index: 1;
  transition: all 0.4s;
  &:hover {
    .background-color {
      background: linear-gradient(
        180deg,
        #3a4074 0%,
        rgba(59, 65, 117, 0.991353) 12.56%,
        rgba(62, 67, 118, 0.96449) 25.13%,
        rgba(67, 71, 121, 0.91834) 37.69%,
        rgba(75, 77, 125, 0.852589) 50.26%,
        rgba(84, 84, 130, 0.768225) 62.82%,
        rgba(96, 92, 136, 0.668116) 75.39%,
        rgba(108, 102, 143, 0.557309) 87.95%,
        rgba(122, 111, 150, 0.442691) 100.52%,
        rgba(134, 121, 157, 0.331884) 113.08%,
        rgba(146, 129, 163, 0.231775) 125.65%,
        rgba(155, 136, 168, 0.147411) 138.21%,
        rgba(163, 142, 172, 0.0816599) 150.78%,
        rgba(168, 146, 175, 0.03551) 163.34%,
        rgba(171, 148, 176, 0.0086472) 175.9%,
        rgba(172, 149, 177, 0) 188.47%
      );
      opacity: 0.7;
      box-shadow: 0px 0px 7px 1px rgba(0, 0, 0, 0.07);
    }
  }
  .background-color {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: linear-gradient(
      180deg,
      #3a4074 0%,
      rgba(59, 65, 117, 0.991353) 6.67%,
      rgba(62, 67, 118, 0.96449) 13.33%,
      rgba(67, 71, 121, 0.91834) 20%,
      rgba(75, 77, 125, 0.852589) 26.67%,
      rgba(84, 84, 130, 0.768225) 33.33%,
      rgba(96, 92, 136, 0.668116) 40%,
      rgba(108, 102, 143, 0.557309) 46.67%,
      rgba(122, 111, 150, 0.442691) 53.33%,
      rgba(134, 121, 157, 0.331884) 60%,
      rgba(146, 129, 163, 0.231775) 66.67%,
      rgba(155, 136, 168, 0.147411) 73.33%,
      rgba(163, 142, 172, 0.0816599) 80%,
      rgba(168, 146, 175, 0.03551) 86.67%,
      rgba(171, 148, 176, 0.0086472) 93.33%,
      rgba(172, 149, 177, 0) 100%
    );
    opacity: 0.7;
    z-index: -1;
  }
}
.news {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;

  .card-5,
  .card-6 {
    grid-column: span 2;
    text-align: center;
    width: 80%;
    padding: 0 production-2rem;
    .background-color {
      background: linear-gradient(
        180deg,
        #3a4074 0%,
        rgba(59, 65, 117, 0.991353) 11.88%,
        rgba(62, 67, 118, 0.96449) 23.76%,
        rgba(67, 71, 121, 0.91834) 35.64%,
        rgba(75, 77, 125, 0.852589) 47.52%,
        rgba(84, 84, 130, 0.768225) 59.39%,
        rgba(96, 92, 136, 0.668116) 71.27%,
        rgba(108, 102, 143, 0.557309) 83.15%,
        rgba(122, 111, 150, 0.442691) 95.03%,
        rgba(134, 121, 157, 0.331884) 106.91%,
        rgba(146, 129, 163, 0.231775) 118.79%,
        rgba(155, 136, 168, 0.147411) 130.67%,
        rgba(163, 142, 172, 0.0816599) 142.55%,
        rgba(168, 146, 175, 0.03551) 154.42%,
        rgba(171, 148, 176, 0.0086472) 166.3%,
        rgba(172, 149, 177, 0) 178.18%
      );
      opacity: 0.7;
      box-shadow: 0px 0px 7px 1px rgba(0, 0, 0, 0.07);
    }
    .card__img {
      display: none;
    }
    .card__brief {
      display: none;
    }
    .card__title {
      padding: 0 1rem;
    }
  }
  .card-6 {
    margin-left: auto;
  }
  .card-1,
  .card-2,
  .card-3,
  .card-4 {
    padding: 1rem;
    .card__img {
      width: 100%;
      // height: 260px;
      .img {
        padding-bottom: 70%;
      }
    }
    .card__title {
      .limited-text {
        --snup: 2;
      }
    }
    .card__brief.limited-text {
      margin-top: 1em;
      --snup: 4;
    }
  }
}
@media screen and (max-width: 992px) {
  .bar-1 {
    padding-top: 4rem;
  }
  .news {
    .card {
      .background-color {
        background: linear-gradient(
          180deg,
          #3a4074 0%,
          rgba(59, 65, 117, 0.991353) 12.56%,
          rgba(62, 67, 118, 0.96449) 25.13%,
          rgba(67, 71, 121, 0.91834) 37.69%,
          rgba(75, 77, 125, 0.852589) 50.26%,
          rgba(84, 84, 130, 0.768225) 62.82%,
          rgba(96, 92, 136, 0.668116) 75.39%,
          rgba(108, 102, 143, 0.557309) 87.95%,
          rgba(122, 111, 150, 0.442691) 100.52%,
          rgba(134, 121, 157, 0.331884) 113.08%,
          rgba(146, 129, 163, 0.231775) 125.65%,
          rgba(155, 136, 168, 0.147411) 138.21%,
          rgba(163, 142, 172, 0.0816599) 150.78%,
          rgba(168, 146, 175, 0.03551) 163.34%,
          rgba(171, 148, 176, 0.0086472) 175.9%,
          rgba(172, 149, 177, 0) 188.47%
        );
        opacity: 0.7;
        box-shadow: 0px 0px 7px 1px rgba(0, 0, 0, 0.07);
      }
    }
    grid-template-columns: repeat(2, 1fr);
    .card-5,
    .card-6 {
      grid-column: span 1;
      width: 100%;
      grid-row: 2;
      padding: 0.5rem 1rem;
    }
    .card-1,
    .card-2,
    .card-3,
    .card-4 {
      padding: 1rem 0.8rem;
    }
  }
}
@media screen and (max-width: 767px) {
  .bar-1 {
    padding-top: 20px;
  }
  .news {
    gap: 1.5rem;
  }

  .card {
    &__brief {
      display: none;
    }
    &__title {
      .limited-text {
        --snup: 4 !important;
      }
    }
  }
}
@media screen and (max-width: 350px) {
  .news {
    gap: 0.5rem;
  }
}
</style>
